/**
 * Reverse geocoding — coordinates to a Google geocode result.
 *
 * The same request-and-guard was hand-written in five screens (create contract,
 * update profile, send estimate, create post, send offer), each repeating the
 * `results[0]` dig and its own emptiness check. One copy drifting gives a silent
 * undefined address in one flow only, so it lives here instead.
 *
 * Returns the whole first result rather than just the address: most callers want
 * `formatted_address`, but update-profile also reads `plus_code` and create-post
 * pulls the locality out of `address_components`.
 *
 * Uses the Geocoding *web service*, which rejects referer-restricted keys — hence
 * `google_geocoding_api_key` rather than the key that loads the Maps JS API.
 */
import axios from "axios";

import { google_geocoding_api_key } from "../constants";

const GEOCODE_URL = "https://maps.googleapis.com/maps/api/geocode/json";

/**
 * Resolves to Google's first geocode result for a coordinate pair, or null when
 * there is none. Rejects if the request itself fails, so callers can tell "no
 * address here" apart from "the lookup broke".
 */
export const reverseGeocode = async (latitude, longitude) => {
  const { data } = await axios(
    `${GEOCODE_URL}?latlng=${latitude},${longitude}&key=${google_geocoding_api_key}`
  );
  return data?.results?.length ? data.results[0] : null;
};

export default reverseGeocode;
